<section class="testimonials-section">
    <div class="container">
      <div class="section__header">
        <h2 class="section__title">Lo que dicen nuestros clientes</h2>
        <p class="section__subtitle">
          Descubre cómo Zapphira.ai está transformando la comunicación digital en empresas de diversos sectores
        </p>
      </div>
      
      <!-- Filtros por tags -->
      <div class="testimonials-filters">
        <h3 class="testimonials-filters__title">Filtrar por sector o caso de uso:</h3>
        <div class="testimonials-filters__tags">
          <button 
            *ngFor="let tag of allTags" 
            class="tag-btn" 
            [class.tag-btn--active]="isTagSelected(tag)"
            (click)="filterByTag(tag)">
            {{ tag }}
          </button>
        </div>
      </div>
      
      <!-- Testimonios -->
      <div class="testimonials-grid">
        <div class="testimonial-card" *ngFor="let testimonial of getCurrentPageTestimonials()">
          <div class="testimonial-card__rating">
            <i 
              *ngFor="let star of generateRatingArray(testimonial.rating)" 
              class="bi" 
              [class.bi-star-fill]="star === 1" 
              [class.bi-star]="star === 0">
            </i>
          </div>
          
          <div class="testimonial-card__content">
            <p>{{ testimonial.content }}</p>
          </div>
          
          <div class="testimonial-card__tags">
            <span class="testimonial-card__tag" *ngFor="let tag of testimonial.tags">{{ tag }}</span>
          </div>
          
          <div class="testimonial-card__author">
            <div class="testimonial-card__avatar">
              <!-- Si existe imagen, mostrarla -->
              <img *ngIf="testimonial.author.image" [src]="testimonial.author.image" [alt]="testimonial.author.name">
              <!-- Si no hay imagen, mostrar las iniciales -->
              <div class="testimonial-card__avatar-initials" *ngIf="!testimonial.author.image">
                {{ getInitials(testimonial.author.name) }}
              </div>
            </div>
            <div class="testimonial-card__author-info">
              <h4 class="testimonial-card__author-name">{{ testimonial.author.name }}</h4>
              <p class="testimonial-card__author-position">{{ testimonial.author.position }}</p>
              <p class="testimonial-card__author-company">{{ testimonial.author.company }}</p>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Paginación -->
      <div class="testimonials-pagination" *ngIf="totalPages.length > 1">
        <button 
          class="pagination-btn" 
          [disabled]="activePage === 1"
          (click)="changePage(activePage - 1)">
          <i class="bi bi-chevron-left"></i>
        </button>
        
        <button 
          *ngFor="let page of totalPages" 
          class="pagination-btn" 
          [class.pagination-btn--active]="page === activePage"
          (click)="changePage(page)">
          {{ page }}
        </button>
        
        <button 
          class="pagination-btn" 
          [disabled]="activePage === totalPages.length"
          (click)="changePage(activePage + 1)">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
      
      <!-- CTA -->
      <div class="testimonials-cta">
        <div class="testimonials-cta__content">
          <h3 class="testimonials-cta__title">¿Quieres ser el próximo caso de éxito?</h3>
          <p class="testimonials-cta__text">Únete a las empresas que ya están transformando su comunicación digital con Zapphira.ai</p>
        </div>
        <div class="testimonials-cta__actions">
          <button class="btn-primary">Solicitar demostración</button>
          <button class="btn-outline">Ver planes</button>
        </div>
      </div>
    </div>
  </section>